/**
 * Created by Ning Jiang on 2021-05-21.
 */

import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DeadwoodRip} from "../DeadwoodRip";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {ReelState} from "../../core/reel/ReelState";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DeadwoodRipReelController} from "../reels/DeadwoodRipReelController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class DeadwoodRipNormalResultPresentation implements FlowStatePresentation {
    private _reelNormalStopDelay:number[] = [0, 0.4, 0.4, 0.4, 0.4];
    private _reelFastStopDelay:number[] = [0, 0.1, 0.1, 0.1, 0.1];
    private _reelNearWinStopDelay:number[] = [3.0, 3.0, 3.0, 3.0, 3.0];
    private _defaultSpinDuration:number;

    constructor() {}

    public start(flowStateController:FlowStateController):void {
        DeadwoodRip.isSpinning = false;
        flowStateController.setSkipCallback(() => this.skip());
        DeadwoodRip.reelStopPresentations.start().then(res => flowStateController.finish());

        if(!this._defaultSpinDuration) {
            // This simple calculation doesn't cover strange stopping order.
            this._defaultSpinDuration = ArrayHelper.arraySum(this._reelNormalStopDelay) + DeadwoodRip.reels[4].getDefaultStoppingTime();
        }

        let delay = 0;
        // The spin time should not leak there is feature later, like a near win. so I use a default spin time here to calculation Jurisdiction padding.
        // fastSpin is off when there is spin time limit, so we don't need to consider it here. To change if something changed.
        const padding = DeadwoodRip.gameFlowController.calculatePaddingDuration(this._defaultSpinDuration);
        if(padding > 0) {
            //Logger.logDev("Added minimum jurisdiction padding  ", padding);
            delay += padding;
        }

        this.getReelsStopResult(false, delay);
    }

    private getReelsStopResult(quickStop:boolean, delay:number):void {
        let spinStopOffset:number = 0;
        DeadwoodRip.reels.forEach((spinReel:DeadwoodRipReelController, reelId:number) => {
            if(spinReel.reelState === ReelState.SPIN) {
                spinStopOffset = Math.max(
                    spinStopOffset,
                    spinReel.getSpinStopOffset());
            }
        });

        DeadwoodRip.reels.forEach((reel, reelId) => {
            delay += this.getReelStopDelay(reel, quickStop); // This is a rough estimated time, the reel will take the real time when it's stopping.
            reel.tryStop(spinStopOffset, delay, quickStop, () => Logger.logDev(`Reel ${reelId} stopping.`));
        });
    }

    private getReelStopDelay(reel:DeadwoodRipReelController, quickStop:boolean):number {
        if(reel.reelState === ReelState.INACTIVE || reel.reelState === ReelState.STOPPING || reel.reelState === ReelState.STOPPED) {
            return 0;
        }

        if(quickStop) {
            return this._reelFastStopDelay[reel.reelId];
        }

        if(reel.hasNearWin()) {
            return this._reelNearWinStopDelay[reel.reelId];
        }

        if(SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            return this._reelFastStopDelay[reel.reelId];
        }

        return this._reelNormalStopDelay[reel.reelId];
    }

    private skip():void {
        Logger.logDev("skip result");
        this.getReelsStopResult(true, 0);
        DeadwoodRip.reelStopPresentations.skip();
    }
}